// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { ClaimTemplate, WithId } from '@quromedical/models';
import { type ColumnType, DataTable } from 'components/table';
import { ClaimTemplateForm, type ClaimTemplate as FormData } from 'core/claim';
import { claimTypeDisplay } from 'core/display';
import { Section, Text, ToggleCard } from 'design-system';
import { router } from 'expo-router';
import { useRevalidation } from 'hooks/useRevalidation';
import { chargeItemFetcher } from 'integration';
import { ClaimTemplateApi } from 'integration/aggregate';
import type { GroupStackScreenProps } from 'navigation';
import type React from 'react';
import { useCallback } from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';
import useSWR from 'swr';

const api = new ClaimTemplateApi();

const columns: ColumnType<WithId<ClaimTemplate>>[] = [
  {
    accessor: 'type',
    header: strings.ClaimTemplateFormLabelService,
    Cell: ({ value }) => <Text>{claimTypeDisplay[value] || value}</Text>,
  } as ColumnType<WithId<ClaimTemplate>, 'type'>,
];

export const ClaimTemplateListScreen: React.FC<
  GroupStackScreenProps<'List'>
> = () => {
  const baseSWRKey = 'claim-template-list';
  const { isValidating, data } = useSWR(baseSWRKey, () =>
    api.getClaimTemplates(),
  );

  const revalidate = useRevalidation(baseSWRKey);

  const handleSubmit = useCallback(
    async (data: FormData) => {
      await api.createClaimTemplate({
        type: data.type,
        chargeLines: data.claimLines.map((line) => ({
          chargeLine: line.chargeItemIdentifier,
          quantity: line.quantity,
        })),
      });

      await revalidate();
    },
    [revalidate],
  );

  const onRowPress = useCallback((row: WithId<ClaimTemplate>) => {
    const id = row.id;
    console.log('row', row.id);
    if (!id) {
      return;
    }

    // Correct way to navigate with params in Expo Router
    router.push({
      pathname: `/admin/claim-template/${id}`,
    });
  }, []);

  return (
    <ScrollView>
      <Section unsetZIndex>
        <ToggleCard
          title={strings.ClaimTemplateFormCreateTitle}
          icon="attach-money"
          textExpand={strings.LabelExpand}
          textCollapse={strings.LabelCollapse}
        >
          <ClaimTemplateForm
            title={strings.ClaimTemplateFormCreateTitle}
            hideCard
            chargeItemFetcher={chargeItemFetcher}
            onSubmit={handleSubmit}
          />
        </ToggleCard>
      </Section>
      <Section>
        <DataTable
          showLoading={isValidating}
          data={data?.claimTemplates || []}
          columns={columns}
          onRowPress={onRowPress}
        />
      </Section>
    </ScrollView>
  );
};
